import useAuth from "hooks/UseAuth"
import { ChangeEvent } from "react"

import DefaultProfile from 'assets/img/default-profile-image.png'
import PicButton from 'assets/img/pic-button.png'

import api from "services/api"
import { Container } from "./_profileImage"
import { toast } from "react-toastify"

export const ProfileImage = () => {
  const { user, updateUser } = useAuth()

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;

    if (files && files.length > 0) {
      const image = files[0];

      try {
        const imageFormData = new FormData();

        imageFormData.append("avatar", image);

        await api.patch('/users/avatar', imageFormData)

        await updateUser()
      } catch (error: any) {
        toast.error(error?.response?.data?.message || 'Oops algo deu errado, tente novamente mais tarde!')
      }
    }
  }

  return  (
    <Container>
      <span
        className="profile-image__content-before-image"
      />
      <img
        className="profile-image__content-image"
        src={user?.avatar_url || DefaultProfile}
        alt="User's profile"
        onError={
          (event: ChangeEvent<HTMLImageElement>) => {
            event.target.src = DefaultProfile
          }
        }
      />
      <label
        className="profile-image__content-edit-button"
      >
        <img
          src={PicButton}
          alt="Edit profile"
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="element---hide"
        />
      </label>
    </Container>

  )
}
